export default {
  pageTitle: '工場見学',
  metaDescription: 'PT Tokki Engineering and Fabrication（TEF）の工場見学にお申し込みください。チカランにある圧力容器・熱交換器の生産設備を実際にご覧いただけます。',
  hero: {
    title: '工場見学',
    subtitle: 'TEFの生産設備と製造工程を実際にご見学いただけます',
  },
  intro: {
    heading: 'TEF工場見学について',
    description: 'PT Tokki Engineering and Fabricationでは、学生・大学・各種団体・お取引先様を対象に、圧力容器、熱交換器、特殊製缶製品の製造工程を実際にご覧いただく機会を設けております。以下のフォームよりお申し込みください。',
  },
  highlights: {
    schedule: { title: '見学スケジュール', desc: '月曜日～金曜日、通常の営業時間内' },
    advanceBooking: { title: '事前予約', desc: 'ご希望日の1ヶ月前までにお申し込みください' },
    groupSize: { title: '参加人数', desc: '団体見学は1回あたり最大40名まで' },
    freeOfCharge: { title: '安全装備', desc: '参加者は安全靴と安全ヘルメットをご自身でご用意ください' },
  },
  terms: {
    heading: '利用規約',
    items: [
      'お申し込みは、ご希望の見学日の7営業日前までにお願いいたします。',
      '安全のため、見学中は肌の露出が少ない服装と、つま先が覆われた靴を着用してください。',
      'スケジュールおよび見学詳細確認のため、TEF担当者よりメールまたはお電話にてご連絡いたします。',
      '工場の稼働状況により、見学日程を変更させていただく場合がございます。',
      'TEFの書面による許可なく、特定エリアでの録画・撮影はご遠慮ください。',
    ],
  },
  form: {
    heading: 'お申し込みフォーム',
    subheading: '工場見学のお申し込みには、以下の項目にご入力ください',
    fullName: 'お名前',
    institutionName: '所属団体・会社名',
    email: 'メールアドレス',
    phoneNumber: '電話番号',
    participants: '参加人数',
    preferredDate: 'ご希望の見学日',
    purpose: '見学目的・備考',
    purposePlaceholder: '見学の目的をご記入ください...',
    submit: '申し込む',
    pleaseWait: '送信中...',
    successMessage: '工場見学のお申し込みを受け付けました。担当者より追ってご連絡いたします。',
    errorMessage: '送信に失敗しました。もう一度お試しください。',
    requiredNotice: '＊印の項目は必須入力です',
  },
};
